import { render, staticRenderFns } from "./CustodyExpenseEdit.vue?vue&type=template&id=6722d065&"
import script from "./CustodyExpenseEdit.vue?vue&type=script&lang=js&"
export * from "./CustodyExpenseEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports